export const LOG_OUT = 'LOG_OUT';
export const LOG_IN = 'LOG_IN';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const RESET_SEARCH = 'RESET_SEARCH';
export const SET_RESULTS = 'SET_RESULTS';
export const SET_QUERY = 'SET_QUERY';
export const SET_NEXT = 'SET_NEXT';
export const RESET_NEXT = 'RESET_NEXT';
